// extracted by mini-css-extract-plugin
export default {"goal":"styles_goal__fIHXZ","header":"styles_header__U7nlV","title":"styles_title__MogXP","description":"styles_description__2iFz5","crown":"styles_crown__jG00R"};